<template>
<div class="chapter">
<div class="inner_page">
<div class="fmb">
<h2 class="fmtitle">acknowledgments</h2>
</div>
<div class="fmbr">
<p class="noindentw">I’d like to thank Gayle Ronconi for her perfect piecing of the quilts, the members of the C&amp;T Publishing editorial department for their ideas and inspiration, and the following companies for providing the wonderful buttons and fabrics used in the quilts:</p>
<p class="noindentw">Dill Buttons</p>
<p class="noindentw">Freespirit Fabrics</p>
<p class="noindentw">Westminster Fabrics</p>
<p class="noindentw">Timeless Treasures Fabrics</p>
<p class="noindentw">RJR Fabrics</p>
<p class="noindentw">P&amp;B Textiles</p>
<p class="noindentw">Quilters Dream Batting</p>
<p class="noindentw">Presencia Threads</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Acknowledgments.vue?4240a040